import { useEffect, useState } from "react";
import HeaderBar from "../../../components/header/headerBar";
import { SearchFieldSelect } from "../../../components/textfield";
// import Input from "../../../components/textfield/input";
import MainButton from "../../../components/button/mainButton";
import "../../../assets/styles/admin/viplist.scss";
import { Table, TableColumn } from "../../../components/table";

import {
  mdiPencilRemoveOutline,
  mdiTrashCanOutline,
  mdiNoteTextOutline,
} from "@mdi/js";
import IconMdi from "@mdi/react";
import { getFileHostUrl } from "../../../helpers/functions";

import { FileAddOutlined } from "@ant-design/icons";

import { Upload, Form, Row, Col, Button, Input, Modal } from "antd";
import axios from "axios";
import { Icon } from "@iconify/react";
import { getLocalUrl } from "../../../functions";
import moment from "moment";

const Viplist = () => {
  const { confirm } = Modal;
  let [formVipList] = Form.useForm();

  const [state, setState] = useState<any>([]);
  const [typeLanguage, setTypeLanguage] = useState<string>("");
  const [file, setFile] = useState<any>([]);

  const option = [{ value: "name", name: "Name" }];

  const column = [
    {
      title: "",
    },
    {
      title: "Name - Surname",
      align: "center",
    },
    {
      title: "Contract File",
      align: "center",
    },
    {
      title: "Added Date",
      align: "center",
    },
    {
      title: "Action",
      align: "center",
    },
  ];

  const onChangeOtherd = (index: string) => {
    console.log("index xxx => ", index);
  };

  const getAPIs = () => {
    axios.get(`/user-vip?search=`).then((res) => {
      setState(res?.data?.data);
    });
  };

  useEffect(() => {
    getAPIs();
  }, []);

  const onFileClick = (url: string) => {
    let fullUrl = url;
    if (!url.startsWith("http")) {
      fullUrl = getFileHostUrl(url);
    }
    window.open(fullUrl, "_blank");
  };

  function showDeleteConfirm(item: any) {
    confirm({
      title: "",
      content: (
        <>
          <div>
            <Icon
              icon="lucide:alert-circle"
              color="#FF6760"
              width="10.6%"
              height="10.6%"
              style={{ marginBottom: "28px" }}
            />
          </div>
          <div>{`ต้องการลบ ${
            item.name + "  " + item?.surName
          } ออกหรือไม่ ?`}</div>
          <div>{`Are you sure delete ${
            item.name + "  " + item?.surName
          } from list?`}</div>
        </>
      ),
      autoFocusButton: null,
      okText: "ตกลง / Submit",
      okType: "danger",
      cancelText: "ยกเลิก / Cancel",
      onOk() {
        Delete(item);
      },
      width: "fit-content",
    });
  }

  const Delete = (item: any) => {
    axios.delete(`/user-vip/${item?._id}`);
    getAPIs();
  };
  const Onsubmit = (values: any) => {
    createData(values);
  };

  const createData = async (values: any) => {
    try {
      const xdata = await axios.post(`/user-vip`, {
        name: values?.name,
        surName: values?.surName,
        typeLang: typeLanguage,
      });
      const _id = xdata?.data?.data?._id;
      const fmData = new FormData();
      const config = {
        headers: { "content-type": "multipart/form-data" },
      };
      fmData.append("file", values?.file?.fileList[0]?.originFileObj);
      await axios.patch(`/user-vip/upload-file/${_id}`, fmData, config);
      getAPIs();
      formVipList.resetFields();
      setFile([]);
    } catch (error) {}
  };
  const onchangePic = (e: any) => {
    const { originFileObj } = e.file;
    const url = getLocalUrl(originFileObj);
    if (e.file.status !== "removed") {
      setFile([
        {
          uid: "1",
          name: e?.file?.name,
          url: url,
        },
      ]);
    } else {
      formVipList.setFieldsValue({ file: "" });
      setFile([]);
    }
  };

  const OnchangeText = (value: any) => {
    var letterNumber = /^[0-9a-zA-Z]+$/;
    if (value.target.value.match(letterNumber)) {
      setTypeLanguage("EN");
    } else {
      setTypeLanguage("TH");
    }
  };

  return (
    <>
      <HeaderBar title="CREATE VIP LIST" />

      <div style={{ padding: "10px 40px" }}>
        <SearchFieldSelect
          option={option}
          color="#FFF"
          placeholder=""
          onChangeOtherd={onChangeOtherd}
        />

        <div
          className="card-view-viplist"
          style={{ padding: "20px 20px", marginTop: "30px" }}
        >
          <Form form={formVipList} onFinish={Onsubmit} layout="vertical">
            <Row justify="space-around" className="head-input">
              <Col span={6} style={{ marginTop: "0px" }}>
                <Form.Item
                  label="Name"
                  name="name"
                  rules={[
                    { required: true, message: "Please input your Name!" },
                  ]}
                >
                  <Input type="text" onChange={(e) => OnchangeText(e)} />
                </Form.Item>
              </Col>
              <Col span={6} style={{ marginTop: "0px" }}>
                <Form.Item
                  label="Surname"
                  name="surName"
                  rules={[
                    { required: true, message: "Please input your Surname!" },
                  ]}
                >
                  <Input type="text" />
                </Form.Item>
              </Col>
              <Col span={5}>
                <Form.Item
                  label="Attach File"
                  name="file"
                  rules={[{ required: true, message: "Please Attach File !" }]}
                >
                  <Upload
                    listType="text"
                    customRequest={({ onSuccess }: any) => {
                      onSuccess();
                    }}
                    accept="image/*,.pdf"
                    fileList={file}
                    onChange={(e: any) => onchangePic(e)}
                  >
                    <Button
                      icon={
                        <Icon
                          icon="fluent:document-copy-48-filled"
                          width="25"
                          height="20"
                          color="#5baea9"
                        />
                      }
                      style={{
                        color: "#5baea9",
                        width: "100%",
                        height: "37px",
                        borderColor: "#5BAEA9",
                        borderRadius: "5px",
                      }}
                    >
                      Attach File
                    </Button>
                  </Upload>
                </Form.Item>
              </Col>
              <Col span={5}>
                <Button
                  className="confirmButton-addvip"
                  htmlType="submit"
                  style={{ marginTop: "40px" }}
                >
                  ADD VIP
                </Button>
              </Col>
            </Row>
          </Form>
        </div>

        <div className="row mt-20">
          <Table header={column}>
            {state.map((item: any, index: number) => (
              <tr key={index} style={{ cursor: "pointer" }}>
                <TableColumn width="3%" align="center">
                  {index + 1}
                </TableColumn>
                <TableColumn align="center">
                  {item?.name + "  " + item?.surName}
                </TableColumn>
                <TableColumn width="12%" align="center">
                  <div onClick={() => onFileClick(item?.fileURL)}>
                    <IconMdi
                      path={mdiNoteTextOutline}
                      size="24"
                      color="#5BAEA9"
                    ></IconMdi>
                    {(item?.fileURL).substring(1, 7)}
                  </div>
                </TableColumn>
                <TableColumn width="10%" align="center">
                  {/* {(item?.formatCreatedAt).substring(0, 8)} */}
                  {moment(item?.updatedAt).format("DD-MM-YYYY")}
                </TableColumn>
                <TableColumn width="10%" align="center">
                  <div onClick={() => showDeleteConfirm(item)}>
                    <Icon
                      icon="icomoon-free:bin"
                      width="20"
                      height="20"
                      color="#FF6760"
                    />
                  </div>
                </TableColumn>
              </tr>
            ))}
          </Table>
        </div>
      </div>
    </>
  );
};
export default Viplist;
